const insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var $searchRendering = $('.search-rendering');

    if(!$searchRendering.length) {
        return;
    }

    var $checkboxes = $searchRendering.find('.search-rendering__filter-checkbox');

    $checkboxes.unbind('click');

    $searchRendering.on('click', '.search-rendering__filter-checkbox', function (e) {       
        updateWindowFilterVars(e.target, true);
    });

    $('body').on('click', '.search-rendering__modaal-filters .search-rendering__filter-checkbox', function (e) {
        updateWindowFilterVars(e.target, false);
    });

    var updateWindowFilterVars = function (checkboxEl, shouldInsertResults) {
        shouldInsertResults = typeof shouldInsertResults !== 'undefined' ? shouldInsertResults : true;        

        window.topics = [];
        window.types = [];
        window.typecategories = [];
        window.page = 1;
        
        if (checkboxEl.checked) {            
            $(checkboxEl).closest('.search-rendering__filter').find('.search-rendering__filter-checkbox').not(checkboxEl).prop('checked', false);
            $(checkboxEl).closest('.search-rendering__filters-height-wrapper').siblings('.search-rendering__filter-checkbox-wrapper').find('.search-rendering__filter-checkbox').prop('checked', false);
        }
        
        var filtersWrapper = $(checkboxEl).closest('.search-rendering__filters-wrapper, .modaal-content-container');
        filtersWrapper.find('.search-rendering__filter-checkbox').filter('input:checked').each(function () {

            var category = $(this).prop('name');
            if (category == 'topics') {
                window.topics.push($(this).val());
            }
            else if (category == 'types') {
                window.types.push($(this).val());
            }
            else if (category == 'typecategories') {
                window.typecategories.push($(this).val());
            }
        });

        if (shouldInsertResults) {            
            if (window.ignoreFilterClickFocusChange == undefined || !window.ignoreFilterClickFocusChange) {
                window.lastSearchRenderingFocusId = checkboxEl.id;                
            }
            window.ignoreFilterClickFocusChange = false;

            insertResults(apiEndpoint);
        }        
    };
};